import { useNotify, useRefresh, Button } from "react-admin";
import BadgeIcon from "@mui/icons-material/Badge";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import { candidateRequests } from "api/candidateApi";
import dataProvider from "server/dataProvider";

const ChangeReinstatesRightsModal = ({ record, specialty }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleConfirm = async () => {
    await dataProvider.customRequest(
      candidateRequests.updateCandidacySpecialityReinstates(record?.id),
      { reinstates: !specialty.reinstatesRights },
      "PUT",
    );
    refresh();
    notify("Успешно сменен статус", { type: "success" });
  };

  return (
    <ConfirmModal
      titleContent="Смени статус"
      onConfirm={handleConfirm}
      triggerButton={
        <Button
          sx={{ width: "max-content" }}
          disabled={record?.hasApprovedRanking}
          startIcon={<BadgeIcon />}
          variant="contained"
          label={`Смени статус на "Възстановяване на права"`}
        />
      }
      message={`Сигурен ли сте, че искате да смените статуса на "Възстановяване на права" ?`}
    />
  );
};

export default ChangeReinstatesRightsModal;
